import PropTypes from 'prop-types';
import React from 'react';

import NavHorizontal from '../lib/NavHorizontal/NavHorizontal';

const BackstageItemListNav = (props, context) => {
  const { tabs, onUpdateTabs } = props;

  const updateTabs = link => {
    if (onUpdateTabs) {
      onUpdateTabs(link);
    } else {
      const { pathname } = context.router.getCurrentLocation();
      if (pathname !== link) {
        context.router.push(link);
      }
    }
  };

  return (
    <div className='BackstageItemListNav'>
      <NavHorizontal links={tabs} onLinkClicked={updateTabs} navType={'tabs'} />
    </div>
  );
};

BackstageItemListNav.propTypes = {
  tabs: PropTypes.array,
  onUpdateTabs: PropTypes.func,
};

BackstageItemListNav.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default BackstageItemListNav;
